import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store';
import { ENUM_BONUS_LABEL, ENUM_CUS_EVENT } from '../../../enums/enums';
import { API_USER } from '../../../api/user';
import useToast from '../../useToast';
import { dispatchCusEvent } from '../../../utils';
import { useDispatch } from 'react-redux';
import { setUpdateBonus } from '../../../store/apps/userSlice';

export default function useEditBonusPhone(groupId) {
  const type = ENUM_BONUS_LABEL.botPhone;
  const { successToast } = useToast();
  const dispatch = useDispatch();
  const bonusBotPhone = useAppSelector((state) => state.user.bonus?.[groupId]?.[type]);

  const [updateSubgroups, setUpdateSubgroups] = useState(false);
  const [botPhoneStruct, setBotPhoneStruct] = useState(
    Array.isArray(bonusBotPhone) ? {} : bonusBotPhone || {}
  );

  const startBotEnable = botPhoneStruct?.enabled;
  const currencies = botPhoneStruct?.values;
  const lockSetting = botPhoneStruct?.updateLocked;
  const saveDisabled = !(currencies && Object.keys(currencies)?.length);

  const changeSubgroup = () => setUpdateSubgroups((prev) => !prev);
  const changeEnable = () => setBotPhoneStruct((prev) => ({ ...prev, enabled: !startBotEnable }));
  const changeLockSetting = () => setBotPhoneStruct((p) => ({ ...p, updateLocked: !lockSetting }));

  const changeFieldValues = (name, value, currency) => {
    setBotPhoneStruct((prev) => {
      const newStartBot = JSON.parse(JSON.stringify(prev));
      if (!newStartBot.values) newStartBot.values = {};
      if (!newStartBot.values[currency]) newStartBot.values[currency] = {};
      newStartBot.values[currency][name] = value;

      return newStartBot;
    });
  };

  const onSave = () => {
    const updateStore = () => {
      // если успех произошёл без ИД - то это создание
      if (!botPhoneStruct.id) {
        dispatchCusEvent(ENUM_CUS_EVENT.getBonusList, { groupId });
        setUpdateSubgroups(false);
        return;
      }
      const bonusData = { id: groupId, bonusName: type, data: botPhoneStruct };
      dispatch(setUpdateBonus(bonusData));
    };

    const updateData = {
      groupId: +groupId,
      bonusLabel: type,
      bonusData: botPhoneStruct,
      updateSubgroups
    };

    API_USER.group.bonus
      .update(updateData)
      .then((e) => {
        updateStore();
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (!bonusBotPhone || Array.isArray(bonusBotPhone)) return;
    setBotPhoneStruct(bonusBotPhone);
  }, [bonusBotPhone]);

  return {
    startBotEnable,
    currencies,
    updateSubgroups,
    lockSetting,
    saveDisabled,
    changeLockSetting,
    changeEnable,
    changeSubgroup,
    changeFieldValues,
    onSave
  };
}
